import React from 'react';
import WorkspaceGuideDialog from '../../../shared/ui/common/WorkspaceGuideDialog';
import type { WorkspaceIntroCardProps } from '../../../shared/ui/common/WorkspaceIntroCard';

interface ValidationGuideDialogProps {
  open: boolean;
  onClose: () => void;
  onStartTour: () => void;
  content: WorkspaceIntroCardProps;
}

const ValidationGuideDialog: React.FC<ValidationGuideDialogProps> = ({
  open,
  onClose,
  onStartTour,
  content,
}) => (
  <WorkspaceGuideDialog
    open={open}
    onClose={onClose}
    dialogTitle="Validation guide window"
    onAction={onStartTour}
    {...content}
  />
);

export default ValidationGuideDialog;
